<div class="userSettingPages">
  <div class="headerDecs">
    <h2>Klarna</h2>
    <span>{{ 'desc_deposit_ueberweisen' | t }}</span>
  </div>

  <ng-container *ngIf="statu == '0'">
    <ng-container *ngIf="this.firststep">
      <div style="width: 100%; display: flex; justify-content: center; margin-top: 5px; margin-bottom: 5px">
        <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
          <mat-button-toggle (click)="changeAmount(25)" value="25">25€</mat-button-toggle>
          <mat-button-toggle (click)="changeAmount(50)" value="50">50€</mat-button-toggle>
          <mat-button-toggle (click)="changeAmount(75)" value="75">75€</mat-button-toggle>
          <mat-button-toggle (click)="changeAmount(100)" value="100">100€</mat-button-toggle>
          <mat-button-toggle (click)="changeAmount(100)" value="150">150€</mat-button-toggle>
          <mat-button-toggle (click)="changeAmount(200)" value="200">200€</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <form [formGroup]="coinbaseDatas" style="width: 100%">
        <mat-form-field style="width: 100%">
          <input matInput placeholder="{{ 'Amount' | t }}" type="number" formControlName="amount" />
          <mat-error *ngIf="!coinbaseDatas.valid">
            Min : <strong>{{ this.MinValue }}</strong> - Max : <strong>{{ this.MaxValue }}</strong>
          </mat-error>
        </mat-form-field>
      </form>

      <button mat-raised-button class="form-submit-button" (click)="submitCoinbaseData()" [disabled]="!coinbaseDatas.valid">{{ 'Pay' | t }}</button>
    </ng-container>

    <ng-container *ngIf="!this.firststep">
      <iframe [src]="iframesrc" style="width: 100%; height: 1100px"></iframe>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="statu == '2'">
    <div style="width: 100%; text-align: center; display: flex; justify-content: center; padding: 20px">
      <div style="width: 150px">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background: new 0 0 512 512"
          xml:space="preserve">
          <ellipse style="fill: #e04f5f" cx="256" cy="256" rx="256" ry="255.832" />

          <g transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 77.26 32)">
            <rect x="3.98" y="-427.615" style="fill: #ffffff" width="55.992" height="285.672" />

            <rect x="-110.828" y="-312.815" style="fill: #ffffff" width="285.672" height="55.992" />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <h2>{{ 'errorcode500' | t }}</h2>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="statu == '1'">
    <div style="width: 100%; text-align: center; display: flex; justify-content: center; padding: 20px">
      <div style="width: 150px">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background: new 0 0 512 512"
          xml:space="preserve">
          <ellipse style="fill: #32bea6" cx="256" cy="256" rx="256" ry="255.832" />

          <polygon
            style="fill: #ffffff"
            points="235.472,392.08 114.432,297.784 148.848,253.616 223.176,311.52 345.848,134.504
	391.88,166.392 " />

          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <h2>{{ 'Payment_Successful' | t }}</h2>
      </div>
    </div>
  </ng-container>
</div>
